// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XStub_XStub__icop0 {
  height: auto;
  width: auto;
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/X/styles/XStub.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,YAAA;AACJ","sourcesContent":[".XStub {\n    height: auto;\n    width: auto;\n    flex-grow: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XStub": `XStub_XStub__icop0`
};
export default ___CSS_LOADER_EXPORT___;
